export const validatePersonalForm = (formData) => {
    const requiredFields = [
      "fullName",
      "gjinia",
      "adresaPersonal",
      "telefon",
      "email",
      "datePersonal",
      "mundësiaPunë",
      "cvFile",
      "startDateAvailable",
      "salaryRangeExpectationMinimum",
      "salaryRangeExpectationMaximum",
      "securityBackgroundChecks",
      "physicalFitRequirement",
      "relativesWorking",
      "jobApplicationNotice",
      "reasonForApplying",
      "nationality",
    ];

    return requiredFields.every((field) => {
      const value = formData[field];
      return value && value.toString().trim() !== "";
    });
  };


  export const validateEducationForm = (formData, isWorkForce) => {
    const educationFields = [
      "educationHighestLevel",
      "educationInstitutionName",
      "educationFieldOfStudy",
      "educationGraduationYearEnd",
    ];

    if (!isWorkForce) {
      educationFields.push("drivingLicense");
    }

    const educationValid = isWorkForce
      ? true
      : educationFields.every((field) => {
          const value = formData[field];
          return value && value.toString().trim() !== "";
        });

    const workExperienceValid = (formData, isWorkForce) => {
      if (isWorkForce) return true;

      if (!formData.workExperience || formData.workExperience.length === 0) {
        return false;
      }

      const hasValidEntry = formData.workExperience.some((experience) => {
        const workFields = [
          "employerName",
          "position",
          "startDate",
          "endDate",
          "responsibilities",
          "employmentReasonForLeaving",
        ];

        return workFields.every((field) => {
          const value = experience[field];
          return value && value.toString().trim() !== "";
        });
      });

      return hasValidEntry;
    };

    const languagesValid = (formData, isWorkForce) => {
      if (isWorkForce) return true;

      if (
        !formData.foreignLanguages ||
        formData.foreignLanguages.length === 0
      ) {
        return false;
      }

      const hasValidLanguage = formData.foreignLanguages.some((language) => {
        return (
          language.language &&
          language.language.trim() !== "" &&
          language.level &&
          language.level.trim() !== ""
        );
      });

      return hasValidLanguage;
    };

    const computerSkillsValid = (formData, isWorkForce) => {
      if (isWorkForce) return true;

      const hasSelectedSkills =
        Object.keys(formData.computerPrograms || {}).length > 0;

      if (formData.computerPrograms && formData.computerPrograms[3]) {
        const otherSkillText = formData.otherComputerSkill;
        return (
          hasSelectedSkills && otherSkillText && otherSkillText.trim() !== ""
        );
      }

      return hasSelectedSkills;
    };

    return (
      educationValid &&
      workExperienceValid(formData, isWorkForce) &&
      languagesValid(formData, isWorkForce) &&
      computerSkillsValid(formData, isWorkForce)
    );
  };

  export const validateDeclarationForm = (formData) => {
    const requiredFields = [
      "dataProtectionAgreement",
      "verificationAuthorization",
    ];

    return requiredFields.every((field) => {
      const value = formData[field];
      return value && value.toString().trim() !== "";
    });
  };